import { connect } from "react-redux";
import { useState } from "react";
import { mapStateToProps } from "../../store/helpers/mapState";
import { mapDispatchToProps } from "../../store/helpers/mapDispatch";
import React, { useEffect } from "react";
import DatatableComponent from "../../helpers/DatatableComponent";
import FormDialog from "../../helpers/FormDialog";
import moment from "moment";
import DeleteDialog from "../../helpers/DeleteDialog";
import { useHistory } from "react-router";
import axios from "axios";
import {
    Button, Link,
    Dialog,
    DialogContent,
    DialogTitle,
    DialogActions
} from "@mui/material";
import SubmitProgramReport from "../../helpers/SubmitProgramReport";
import StatusLayout from "components/Status";

function ViewSubmittedProgramReports({ location, SetSelectedMenu, FetchDetails, resourceId, loggedUser, resources }) {
    const [open, setOpen] = useState(0);
    const [value, setValue] = useState({});
    // const [list, setList] = useState([]);
    const [id, setId] = useState();
    const [departments, setDepartments] = useState([]);
    const [reportedBy, setReportedBy] = useState([]);
    const [program, setProgram] = useState();
    const [count, setCount] = useState(0);
    const [deleteOpen, setDeleteOpen] = useState(false);
    const [openSubmitDialog, setOpenSubmitDialog] = React.useState(false);
    const [processedData, setProcessedData] = React.useState([]);

    const { startDate, endDate, reportId } = location.state || {};
    const [challengeModalOpen, setChallengeModalOpen] = React.useState(false);
    const [currentChallenge, setCurrentChallenge] = React.useState("");

    const [statusModalOpen, setStatusModalOpen] = React.useState(false);
    const [currentStatus, setCurrentStatus] = React.useState("");


    useEffect(() => {
        if (startDate && endDate && reportId) {
            const fetchData = async (startDate, endDate, reportId) => {
                const response = await FetchDetails(`/api/program/list/submitted-report?count=${count}&reportId=${reportId}`);

                if (response.status) {
                    // setList(response.data.data);
                }
            };

            fetchData(startDate, endDate, reportId);
        }
    }, [startDate, endDate, reportId, FetchDetails, count]);


    const handleSubmitSuccess = () => {
        setCount((v) => v + 1);
    };

    const history = useHistory();

    useEffect(() => {
        SetSelectedMenu({
            menu: "program",
            title: "Program Management",
        });
        fetchDepartments();
        fetchResources();

    }, []);


    const fetchDepartments = async () => {
        const response = await await FetchDetails(`/api/departments/list`);
        if (response.status) {

            setDepartments(response?.data?.data);
        }
    };

    const fetchResources = async () => {
        const response = await FetchDetails(`/api/resource/listAll`);
        if (response.status) {
            setReportedBy(response?.data.data);
        }
    };
    const handleViewChallenge = (challenge) => {
        setCurrentChallenge(challenge);
        setChallengeModalOpen(true);
    };

    const handleCloseChallengeModal = () => {
        setChallengeModalOpen(false);
        setCurrentChallenge("");
    };

    const handleViewStatus = (status) => {
        setCurrentStatus(status);
        setStatusModalOpen(true);
    };

    const handleCloseStatusModal = () => {
        setStatusModalOpen(false);
        setCurrentStatus("");
    };


    const columns = [
        {
            name: "name",
            label: "Name",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value) => (
                    <span className="text-custom-blue text-xs ">{value}</span>
                ),
            },
        },
        {
            name: "date",
            label: "Date",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value) => (
                    <span className="text-custom-blue text-xs ">{moment(value).format("YYYY-MM-DD")}</span>
                ),
            },
        },
        {
            name: "impact",
            label: "Impact",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value) => (
                    <span style={{
                        color: value === "high" ? "#FFA710" : value === "medium" ? "orange" : "#E41010",
                        fontSize: "13.92px"
                    }} className={"text-custom-blue text-xs "}>{value}</span>
                ),
            },
        },

        {
            name: "divisionId",
            label: "Division",
        },
        {
            name: "overallStatus",
            label: "Overall Status",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value) => {
                    const displayText = value
                        ? value.length > 10
                            ? value.substring(0, 10) + "..."
                            : value
                        : "";
                    return (
                        <Link
                            href="#"
                            onClick={(e) =>
                                e.preventDefault() ||
                                handleViewStatus(value)}
                            sx={{ textDecoration: 'none', color: 'black', cursor: 'pointer' }}
                        >
                            {displayText}
                        </Link>
                    );
                },
            },
        },
        {
            name: "challenges",
            label: "Challenges",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value) => {
                    const displayText = value
                        ? value.length > 10
                            ? value.substring(0, 10) + "..."
                            : value
                        : "";
                    return (
                        <Link
                            href="#"
                            onClick={(e) =>
                                e.preventDefault() ||
                                handleViewChallenge(value)}
                            sx={{ textDecoration: 'none', color: 'black', cursor: 'pointer' }}
                        >
                            {displayText}
                        </Link>
                    );
                },
            },
        },
        {
            name: "Resource.names",
            label: "Reported By",
            // options: {
            //     filter: true,
            //     sort: true,
            //     customBodyRender: (value) => (
            //         <span className="text-custom-blue text-xs ">{reportedBy.find((x) => x.id === value)?.names}</span>
            //     ),
            // },
        },

        {
            name: "status",
            label: "Status",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value) => (
                    <StatusLayout status={value ?? "not available"} />
                ),
            },
        }
    ];
    const setValue0 = (name, val) => {
        if (!name) {
            return null;
        }

        setValue((v) => {
            v[name] = val;
            return { ...v };
        });
    };
    const onSuccess = () => setCount((v) => v + 1);
    return (
        <div className="w-full mb-12 px-4">



            <SubmitProgramReport
                open={openSubmitDialog}
                onClose={() => setOpenSubmitDialog(false)}
                onSuccess={handleSubmitSuccess}
                SubmitGeneralForm={async (url, formData) => {
                    try {
                        const response = await axios.post(url, formData, {
                            headers: { "Content-Type": "multipart/form-data" },
                        });
                        return { status: response.status === 200, data: response.data };
                    } catch (error) {
                        return { status: false };
                    }
                }}

                startDate={moment(startDate).format("YYYY-MM-DD")}
                endDate={moment(endDate).format("YYYY-MM-DD")}
                loggedUser={loggedUser}
                resources={resources}
                processData={processedData}

            />

            <DeleteDialog
                open={deleteOpen}
                setOpen={() => setDeleteOpen(false)}
                onSuccess={onSuccess}
                url={`/api/program/submited-report/delete/${id}`}
            />

            <Dialog
                open={challengeModalOpen}
                onClose={handleCloseChallengeModal}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle>Challenge Details</DialogTitle>
                <DialogContent>
                    <div dangerouslySetInnerHTML={{ __html: currentChallenge }} />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseChallengeModal} color="primary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={statusModalOpen}
                onClose={handleCloseStatusModal}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle>Status Details</DialogTitle>
                <DialogContent>
                    <div dangerouslySetInnerHTML={{ __html: currentStatus }} />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseStatusModal} color="primary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>

            <FormDialog
                maxWidth={"md"}
                col={6}
                open={open > 0}
                onSuccess={onSuccess}
                setOpen={setOpen}
                url={open === 1 ? "/api/program/report/create" : `/api/program/submited-report/update/${id}`}
                title={open === 1 ? "Create New program Report" : "Edit program report"}
                fields={[


                    {
                        name: "name",
                        label: "Program name",
                        value: value["name"],
                        required: true,
                        setValue: (val) => setValue0("name", val),
                    },
                    {
                        name: "code",
                        label: "Code",
                        type: "text",
                        value: value["code"],
                        required: true,
                        setValue: (val) => setValue0("code", val),
                    },
                    {
                        name: "date",
                        label: "Date",
                        type: "date",
                        required: true,
                        value: value["date"],
                        options: {
                            filter: true,
                            sort: true,
                            customBodyRender: (value) => (
                                <span className="text-custom-blue text-xs ">{moment(value).format("YYYY-MM-DD")}</span>
                            ),
                        },
                    },
                    {
                        name: "impact",
                        label: "Impact",
                        type: "select",
                        values: [
                            { label: "High", value: "high" },
                            { label: "Medium", value: "medium" },
                            { label: "Low", value: "low" },
                        ],
                        value: value["impact"],
                        setValue: (val) => setValue0("impact", val)
                    },
                    {
                        name: "currency",
                        label: "currency",
                        value: "Rwf",
                        required: false,
                        type: "text",
                        hidden: true,
                        setValue: (val) => setValue0("currency", val),
                    },
                    {
                        name: "status",
                        label: "Status",
                        value: value["status"],
                        required: true,
                        options: {
                            filter: true,
                            sort: true,
                            customBodyRender: (value) => (
                                <span className="text-custom-blue text-xs ">{value}</span>
                            ),
                        },
                    },
                    {
                        name: "department",
                        label: "Select Department",
                        value: value["department"],
                        values: departments && departments.map((x) => ({
                            label: x.name,
                            value: x.id,
                        })),
                        required: false,
                        type: "select",
                        setValue: (val) => setValue0("department", val),
                    },
                    {
                        name: "divisionId",
                        label: "Division",
                        value: value["divisionId"],
                        values: departments.find((x) => x.id === value["department"])?.divisions.map((x) => ({
                            label: x.name,
                            value: x.id,
                        })),
                        required: false,
                        type: "select",
                        setValue: (val) => setValue0("divisionId", val),
                    },

                    {
                        name: "overallStatus",
                        label: "Overall Status",
                        value: value["overallStatus"],
                        required: false,
                        type: "editor",
                        col: 12,
                        setValue: (val) => setValue0("overallStatus", val),
                    },
                    {
                        name: "challenges",
                        label: "Challenges",
                        value: value["challenges"],
                        required: false,
                        type: "editor",
                        col: 12,
                        setValue: (val) => setValue0("challenges", val),
                    },


                ]}
            />
            <DatatableComponent
                order={location?.state?.order}
                processData={(data) => {
                    // setList(data.data);
                    setProcessedData(data.data);
                    return data;
                }}
                elevation={1}
                pdf={true}
                excel={false}
                columns={columns}
                viewColumns={false}
                searchfield={true}
                search={false}
                // submitReport={true}
                onSubmitReport={() => {
                    setOpenSubmitDialog(true);
                }}
                url={`/api/program/list/submitted-report?count=${count}${startDate ? `&startDate=${startDate}` : ''}${endDate ? `&endDate=${endDate}` : ''}${reportId ? `&reportId=${reportId}` : ''}`}

                title={`Weekly Program Reports from ${startDate ? moment(startDate).format("YYYY-MM-DD") : "    "} to ${endDate ? moment(endDate).format("YYYY-MM-DD") : ""}`}

            />
        </div>
    );
}

export default connect(mapStateToProps, mapDispatchToProps)(ViewSubmittedProgramReports);
